import React from "react";
import cn from "classnames";
import { Dropdown, Nav } from "react-bootstrap";

import timeZones from "../../config/timeZones";
import styles from "./styles.module.scss";
import ChevronRightIcon from "components/common/icons/ChevronRightIcon";

function TimeZone({ short, long, setTimeZone, timeZone }) {
  return (
    <div className="text-end">
      <Dropdown>
        <Dropdown.Toggle
          id="timezone-dropdown"
          bsPrefix="custom-menu"
          variant="light"
          as={Nav.Link}
          className={cn(
            "d-inline-flex align-items-center px-0",
            styles.dropdownMenu
          )}
        >
          <div className="fw-bold">
            Your Time Zone: <span className="text-danger">{short}</span>
          </div>
          <ChevronRightIcon down className="ms-2 text-danger" />
        </Dropdown.Toggle>

        <Dropdown.Menu align="right" className={styles.dropdown}>
          <Dropdown.Header>Choose another Time Zone</Dropdown.Header>
          {Array.isArray(timeZones) &&
            timeZones.map((zone, index) => (
              <Dropdown.Item
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setTimeZone(zone.utc[0]);
                }}
                className={cn(
                  zone.utc[0] === timeZone && styles.activeTZ,
                  styles.timeZone
                )}
              >
                {zone.value}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
      <sup>{long}</sup>
      <div>Schedule is shown according to your Time Zone</div>
    </div>
  );
}

export default TimeZone;
